<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'

defineProps({
    isContainedInDrawer: {
        type: Boolean,
        required: true
    }
})

const poolStore = usePoolStore()
const cdnUrl = useRuntimeConfig().app.cdnURL
const userId = useUserSession().user?.value?.id

const onClickOn = () => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            { action: 'openUrl', url: '/user/index' },
            document.referrer
        )
    } else {
        return navigateTo(getChargemapUrl('/user/index'), { external: true })
    }
}

const onClickOnAddPicture = () => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            { action: 'openUrl', url: `wizard/${poolStore.poolId}#6` },
            document.referrer
        )
    } else {
        return navigateTo(getChargemapUrl(`/wizard/${poolStore.poolId}#6`), {
            external: true
        })
    }
}
</script>

<template>
    <div class="flex flex-col gap-8 p-4">
        <div
            class="flex flex-col justify-center sm:mx-12 text-center items-center"
            :class="{
                'gap-4': !isContainedInDrawer,
                'mt-3': isContainedInDrawer
            }"
        >
            <NuxtImg
                class="px-8 mb-1"
                loading="lazy"
                :src="`${cdnUrl}/images/NoPicture.svg`"
                :alt="$t(`add_photos`)"
            />
            <h2 class="w-max font-semibold text-lg">{{ $t('add_photos') }}</h2>
            <span
                class="flex font-normal text-sm sm:text-seventeen-exploitation text-leading-5 text-gray-l-700"
            >
                {{ $t(`no_picture_desc`) }}
            </span>
        </div>
        <div
            v-if="!userId"
            class="flex flex-col justify-center gap-2 mx-4 mb-4 text-center"
        >
            <ChargemapB2CButton
                type="primary"
                size="large"
                custom="full-width"
                @click="onClickOn()"
            >
                {{ $t('join_chargemap.signup') }}
            </ChargemapB2CButton>
            <div class="flex items-center justify-center gap-1 425:gap-2 pt-2">
                <span
                    class="text-thirteen-exploitation 425:text-seventeen-exploitation leading-4 425:leading-5 tracking-light gtm-InscriptionConnexionMap"
                >
                    {{ $t('join_chargemap.signin1') }}
                </span>
                <ChargemapB2CButton
                    type="tertiary"
                    class="p-0 text-thirteen-exploitation 425:text-seventeen-exploitation"
                    @click="onClickOn()"
                >
                    {{ $t('join_chargemap.signin2') }}
                </ChargemapB2CButton>
            </div>
        </div>
        <div v-else class="flex flex-col justify-center m-4 mt-0">
            <ChargemapB2CButton
                type="primary"
                size="large"
                @click="onClickOnAddPicture"
            >
                {{ $t('add_photos') }}
            </ChargemapB2CButton>
        </div>
    </div>
</template>
